import { gql } from "lib/apolloClient";

export const organizationSubjectFragment = {
  organizationSubject: gql`
    fragment organizationSubjectItem on Subject {
      id
      name
      isArchived
    }
  `,
};
